import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UrlService } from '@core/services/url/url.service';
import { AmsFile } from '@core/objects/ams-file';

@Component({
    selector: 'core-files-list-checkbox',
    templateUrl: './files-list-checkbox.component.html',
    styleUrls: ['./files-list-checkbox.component.scss']
})
export class FileListCheckboxComponent implements OnInit {

    @Input() files: Array<AmsFile>;
    @Input() maxSelected: number = 0; // Max files can be selected (0 = unlimited)
    @Input() disabled: boolean; // TODO

    @Input()  selected: Array<AmsFile>;
    @Output() selectedChange = new EventEmitter<Array<AmsFile>>();

    constructor() { }

    ngOnInit() {

    }

    toogleFile(file: AmsFile) {
        console.log(file, this.selected);
        if(this.existsFile(file)) {
            this.selected = this.selected.filter(f => f.id != file.id);
            console.log("entra", file, this.selected);
        }
        else {
            if(!this.disabled)
                this.selected.push(file);
        }

        this.selectedChange.emit(this.selected);
    }

    existsFile(file: AmsFile) : boolean {
        let files = this.selected.filter(f => f.id == file.id);

        return files.length > 0;
    }


    protected getFileExtension(name: string): string {
        const cleanName = name.split(' ').pop() || name;
        const parts = cleanName.split('.');
        return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
    }

    protected humanFileSize(size: number): string {
        var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
        return +(size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
    }


}
